import BaseService from './baseService';
const rota = 'destaques-home';
const service = new BaseService(rota);

const getList = async (body, skip, limit) => {
    const res = await service.getList(body, skip, limit);
    return res;
}

const getListHome = async () => {
    const body = {
        params: [
            
            { field: "active", operator: "equal", value: true },
        ],
        sort: 'ordem'
    }
    const res = await service.getList(body, 0, 99999);
    return res;
}

const getById = async (id) => {
    const res = await service.getById(id);
    return res;
}

const reorder = async (body) => {
    const res = await service.reorder(body);
    return res;
}

const upsert = async (body, id) => {
    const res = await service.upsert(body, id);
    return res;
}

export default { getList, getListHome, getById, upsert, reorder };
